import Box from "@mui/material/Box";

export const FlexBox = (props) => {
  const {
    children,
    alignItems = "center",
    flexDirection = "row",
    flexGrow,
    flexWrap,
    justifyContent,
    gap = 2,
    sx,
    ...restProps
  } = props;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems,
        justifyContent,
        flexDirection,
        flexGrow,
        flexWrap,
        gap,
        ...sx,
      }}
      {...restProps}
    >
      {children}
    </Box>
  );
};
